import { render, staticRenderFns } from "./CreatePackage.vue?vue&type=template&id=6e36716b&"
import script from "./CreatePackage.vue?vue&type=script&lang=js&"
export * from "./CreatePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports